<template>
	<div class="card border-2">
		<div class="card-body vstack gap-1">
			<div class="vstack">
				<div class="hstack gap-2 justify-content-between">
					<span class="text-sm fw-semibold text-muted" v-tooltip:right="detail.description">{{ detail.title }}</span>
					<span class="text-sm fw-semibold text-muted" v-tooltip:left="`Comisión alcanzada`" v-if="detail.main">
						{{ vueNumberFormat(currentLevel?.commission ?? 0, { suffix: ` %`, precision: 2 }) }}
					</span>
				</div>
				<span class="h3 fw-bold">
					<span v-if="exchange" v-tooltip:bottom="`<div class='text-xs lh-xs pb-1'>Este monto ha sido convertido al tipo de cambio actual. El valor puede variar según las fluctuaciones del mercado.</div>Original: ${vueNumberFormat(detail.amount ?? 0, { suffix: ` ${goal.currency}`, precision: 2 })}`">
						{{ vueNumberFormat(((detail.amount ?? 0) * exchange.rate), { suffix: ` ${exchange.to}`, precision: 2 }) }}
						<i class="bi bi-arrow-left-right text-md ps-1"></i>
					</span>
					<span v-else>
						{{ vueNumberFormat(detail.amount ?? 0, { suffix: ` ${goal.currency}`, precision: 2 }) }}
					</span>
				</span>
			</div>
			<!-- Progress -->
			<div class="vstack lh-1">
				<div class="d-flex align-items-center justify-content-between mb-1">
					<span class="text-sm text-muted d-block">{{ vueNumberFormat(nextLevelPercentage, { suffix: ` %`, precision: 0 }) }}</span>
					<span class="text-sm text-muted d-block" v-tooltip:left="nextLevelTooltip">{{ currentLevel?.name ?? 'Sin nivel alcanzado' }}</span>
				</div>
				<div class="progress progress-sm shadow-none">
					<div class="progress-bar" :class="nextLevelBarClass" role="progressbar" :style="{ width: `${nextLevelPercentage}%` }"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { computed } from 'vue';

	export default {
		props: {
			detail: Object,
			goal: Object,
			exchange: Object
		},
		setup(props) {
			let numberFormat = new Intl.NumberFormat('es-ES');

			const currentLevel = computed(() => {
				if(props.detail.level.current_level != null) {
					return props.goal.levels[props.detail.level.current_level];
				}else{
					return null;
				}
			});

			const nextLevelTooltip = computed(() => {
				let data = [];

				if(props.detail.level.current_level != null) {
					data.push(`Nivel alcanzado: ${props.goal.levels[props.detail.level.current_level].name}`);
				}else{
					data.push(`Sin nivel alcanzado`);
				}

				if(props.detail.level.next_level != null) {
					data.push(`Siguiente nivel: ${props.goal.levels[props.detail.level.next_level].name}`);

					if(props.exchange) {
						data.push(`Monto: ${numberFormat.format((props.detail.level.next_level_threshold) * props.exchange.rate)} ${props.exchange.to}`);
						data.push(`Original: ${numberFormat.format(props.detail.level.next_level_threshold)} ${props.goal.currency}`);
					}else{
						data.push(`Monto: ${numberFormat.format(props.detail.level.next_level_threshold)} ${props.goal.currency}`);
					}
				}else{
					data.push(`Nivel más alto`);
				}

				return data.join('<br>');
			});

			const nextLevelPercentage = computed(() => {
				let percentage = 0;

				if(props.detail.level.next_level_threshold != null) {
					percentage = ((props.detail.amount ?? 0) * 100) / props.detail.level.next_level_threshold;
				}else{
					percentage = 100;
				}

				return Math.round(percentage * 100) / 100;
			});

			const nextLevelBarClass = computed(() => {
				if(nextLevelPercentage.value < 50) return 'bg-danger';
				else if(nextLevelPercentage.value < 80) return 'bg-warning';
				else return 'bg-success';
			});

			return { currentLevel, nextLevelTooltip, nextLevelPercentage, nextLevelBarClass };
		}
	}
</script>